<template>
  <div>
    <v-layout row align-center justify-begin>
      <v-tooltip bottom>
        <span>Export account statement in PDF</span>
        <v-btn
          slot="activator"
          :disabled="generatingPdf"
          small
          flat
          color="red"
          @click="exportAsPDF()"
        >
          <v-icon small class="pr-2">mdi-pdf-box</v-icon>Download PDF
        </v-btn>
      </v-tooltip>
      <v-tooltip bottom>
        <span>Export account statement in XLSX</span>
        <!-- TODO: FIX THIS SHITTY PADDING + on over layout -->
        <exportExcel
          slot="activator"
          button_label="Download XLSX"
          :filename="excelData.filename"
          :sheetsLabels="excelData.sheetsLabels"
          :sheetsData="excelData.sheetsData"
          :propsControl="true"
          @runExport="exportAsXLSX()"
          :exportTriggerKey="excelData.exportTriggerKey"
          :small="true"
        />
      </v-tooltip>

      <send-pdf-mail-modale
        :modaleTitle="
          'Send <b>' +
          companyBalance.company.name +
          '</b> account statement PDF by email'
        "
        buttonText="Send Email"
        :pdfBody="pdfHtml()"
        :pdfFileName="'account_statement'"
        :recipients="mailRecipients"
        :defaultMailContent="'Dear partner,\n\nPlease find attached a copy of your account statement.\n{{PDF_BUTTON}}\nBest Regards.'"
        defaultSubject="Account statement"
        defaultDownloadButtonText="Consult my account statement"
        formId="account_statement"
        :recipientsLanguages="companyBalance.company.language_ids"
        :interpolations="interpolations"
      />

      <v-spacer></v-spacer>

      <v-tooltip
        dark
        color="amber darken-2"
        left
        v-if="itemsToDisplay.length != statementItems.length"
      >
        <v-chip
          class="mr-5"
          dark
          style="cursor: pointer; padding-top: 3px; padding-bottom: 3px"
          slot="activator"
          color="amber darken-2"
          @click="datePickerUpdate('All')"
        >
          <v-icon small color="white">mdi-filter-variant</v-icon>
          <strong style="cursor: pointer" class="white--text">{{
            statementItems.length - itemsToDisplay.length + " item(s) filtered"
          }}</strong>
        </v-chip>
        <span>Clear filter</span>
      </v-tooltip>

      <v-menu
        ref="datePickerMenu"
        v-model="datePickerMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="280px"
        min-width="280px"
        allow-overflow
        persistent
      >
        <template v-slot:activator="{ on }">
          <div style="width: 220px">
            <v-text-field
              :value="
                timeToDate(datePickerFrom) + ' - ' + timeToDate(datePickerTo)
              "
              v-on="on"
              hide-details
              inline
              :label="'Date range: ' + datePickerRangeSelectedItem"
              flat
              class="pt-0"
              readonly
              :append-icon="datePickerMenu ? 'mdi-menu-up' : 'mdi-menu-down'"
            ></v-text-field>
          </div>
        </template>

        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <!-- Range selection -->
              <v-select
                :items="datePickerRangeItems"
                v-model="datePickerRangeSelectedItem"
                label="Date Range"
                dense
                :menu-props="{ zIndex: '1000' }"
                @change="datePickerUpdate($event)"
              ></v-select>
            </v-layout>
            <v-layout row wrap>
              <!-- Picker From -->
              <v-flex xs6 pr-2>
                <v-menu
                  ref="datePickerShowFrom"
                  v-model="datePickerShowFrom"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      :value="timeToDate(datePickerFrom)"
                      v-on="on"
                      hide-details
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575"
                          >event</v-icon
                        >From
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="datePickerFrom"
                    no-title
                    @input="selectedDatePickerFrom()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- Picker To -->
              <v-flex xs6 pl-2>
                <v-menu
                  ref="datePickerShowTo"
                  v-model="datePickerShowTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      :value="timeToDate(datePickerTo)"
                      v-on="on"
                      hide-details
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575"
                          >event</v-icon
                        >To
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="datePickerTo"
                    no-title
                    @input="selectedDatePickerTo()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-layout>

    <v-dialog v-model="showInvoiceDialog" width="1024" scrollable>
      <v-card>
        <v-card-title
          v-if="showInvoiceObject"
          class="title grey--text text--darken-2"
        >
          <v-layout row wrap align-center>
            <v-icon class="pr-2" small>mdi-file-document</v-icon>
            <span class="align-center">{{
              showInvoiceObject.designation
            }}</span>
            <v-spacer></v-spacer>
            <v-chip
              class="px-1"
              style="height: 18px"
              dark
              :color="showInvoiceObject.account_type.color"
            >
              <v-icon
                v-show="
                  showInvoiceObject.account_type.icon &&
                  showInvoiceObject.account_type.icon != 'null'
                "
                class="pr-1"
                size="11"
                style="position: relative; top: -2px"
                >{{ showInvoiceObject.account_type.icon }}</v-icon
              >
              {{ showInvoiceObject.account_type.name }}
            </v-chip>
          </v-layout>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <invoiceDetailedPreview
            v-if="showInvoiceObject"
            :invoice="showInvoiceObject"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="error" small flat @click="showInvoiceDialog = false">
            <v-icon small class="pr-2">close</v-icon>Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card flat>
      <v-layout row wrap></v-layout>
      <v-layout row wrap class="text-xs-center pa-5" v-if="generatingPdf">
        <v-flex xs12>
          <v-layout
            style="height: 300px"
            column
            align-center
            class="text-xs-center"
          >
            <v-spacer></v-spacer>
            <v-flex class="text-xs-center">
              <breeding-rhombus-spinner
                style="margin: auto"
                class="text-xs-center"
                :animation-duration="1000"
                :size="80"
                color="#1976d2"
              />

              <h3 style="color: #555" class="pt-4">
                Please wait during PDF creation.
              </h3>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-data-table
        ref="accountStatementTable"
        :headers="headers"
        :items="itemsToDisplay"
        v-if="!generatingPdf"
        :rows-per-page-items="[
          50,
          100,
          150,
          250,
          1000,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template v-slot:items="props">
          <tr
            v-show="!props.item.hidden"
            @click="
              props.item.type == 'invoice'
                ? displayInvoicePreview(props.item.invoice)
                : ''
            "
          >
            <td class="text-xs-left">{{ props.item.date }}</td>
            <td class="text-xs-left">{{ props.item.reference }}</td>
            <td class="text-xs-left">
              <strong
                :class="
                  amountColorClass(
                    'invoice',
                    props.item.invoiced,
                    props.item.operation_type
                  )
                "
                >{{ amountAsText(props.item, "invoice") }}</strong
              >
            </td>
            <td class="text-xs-left">
              <strong
                :class="
                  amountColorClass(
                    'transaction',
                    props.item.paid,
                    props.item.operation_type
                  )
                "
                >{{ amountAsText(props.item, "transaction") }}</strong
              >
            </td>
            <td class="text-xs-left">
              {{ inCurrencyFromId(currencyId, props.item.balance) }}
            </td>
          </tr>
        </template>

        <template v-slot:footer>
          <td></td>
          <td class="text-xs-right">Total:</td>
          <td class="text-xs-left">
            <strong>{{ inCurrencyFromId(currencyId, total_invoiced) }}</strong>
          </td>
          <td class="text-xs-left">
            <strong>{{ inCurrencyFromId(currencyId, total_paid) }}</strong>
          </td>
          <td class="text-xs-left">
            <strong
              :style="'color: #' + (total_balance >= 0 ? '4CAF50' : 'FF5252')"
              >{{ inCurrencyFromId(currencyId, total_balance) }}</strong
            >
          </td>
        </template>
      </v-data-table>
      <!-- <div v-html="pdfHtml()"></div> -->
      <!-- <json-viewer :value="statementItems" sort></json-viewer> -->
      <!-- <json-viewer :value="companyBalance" sort></json-viewer>-->
      <!-- datePickerFrom: {{datePickerFrom}} -->
      <!-- <br />
      datePickerTo: {{datePickerTo}} -->
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BreedingRhombusSpinner } from "epic-spinners";
import JsonViewer from "vue-json-viewer";

import currency from "../../../mixins/currency.js";
import exportExcel from "../../shared/exportExcel";
import date from "../../../mixins/date.js";
import invoiceDetailedPreview from "../invoices/invoiceDetailedPreview";
import ctc_header_pdf from "raw-loader!../../../../public/templates/ctc_header_pdf.html";
import ACCOUNTING_STATEMENT_PDF_BLOB from "../../../graphql/pdf/accounting_statement_pdf.gql";
import sendPdfMailModale from "../../shared/sendPdfMailModale";
export default {
  name: "companyAccountHistory",
  mixins: [currency, date],
  components: {
    BreedingRhombusSpinner,
    exportExcel,
    invoiceDetailedPreview,
    JsonViewer,
    sendPdfMailModale,
  },
  props: {
    invoices: {
      type: Array,
      required: true,
    },
    transactions: {
      type: Array,
      required: true,
    },
    companyName: {
      type: String,
      required: false,
      default: "",
    },
    currencyId: {
      type: String,
      required: true,
    },
    companyBalance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      datePickerFrom: new Date(this.monthsAgo(6)).toISOString().substr(0, 10),
      datePickerTo: new Date().toISOString().substr(0, 10),
      datePickerShowFrom: false,
      datePickerShowTo: false,
      datePickerMenu: false,
      datePickerRangeItems: [
        "Custom",
        "Last 3 months",
        "Last 6 months",
        "This year",
        "All",
      ],
      datePickerRangeSelectedItem: "Last 6 months",
      pagination: [
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
      ],
      excelData: {
        filename: "account_statement.xlsx",
        sheetsLabels: ["Account Statement"],
        sheetsData: [],
        exportTriggerKey: 0,
      },
      ctc_header_pdf,
      showInvoiceDialog: false,
      showInvoiceObject: null,
      generatingPdf: false,
      total_invoiced: 0,
      total_paid: 0,
      total_balance: 0,
      showMailModale: false,
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date",
        },
        {
          text: "Reference",
          align: "left",
          sortable: false,
          value: "reference",
        },
        {
          text: "Invoices",
          align: "left",
          sortable: false,
          value: "invoiced",
        },
        {
          text: "Payments",
          align: "left",
          sortable: false,
          value: "paid",
        },
        {
          text: "Balance",
          align: "left",
          sortable: false,
          value: "balance",
        },
      ],
    };
  },
  computed: {
    interpolations() {
      return [
        {
          interpolation: "{{company_name}}",
          value: this.companyBalance.company.name,
        },
        {
          interpolation: "{{company_short_name}}",
          value: this.companyBalance.company.short_name,
        },
        {
          interpolation: "{{contact_commercial_names}}",
          value: this.companyBalance.company.company_contacts
            .map((e) => e.username)
            .join(),
        },
      ];
    },
    mailRecipients() {
      if (this.companyBalance.company.company_contacts.length)
        return [
          ...new Set(
            this.companyBalance.company.company_contacts
              .map((cc) => cc.emails.map((ccm) => ccm.value))
              .flat()
          ),
        ];
      return [];
    },
    datePickerFromAsDateObject() {
      return this.strToTimestamp(this.datePickerFrom, "YYYY-MM-DD");
    },
    datePickerToAsDateObject() {
      return this.strToTimestamp(this.datePickerTo, "YYYY-MM-DD");
    },
    invoiceTransactionsAndTransfers() {
      // Building array of values that merge initial value, transfer, transactions and invoice.
      var array = [];

      this.total_balance = this.companyBalance.initial_value;

      this.invoices.forEach((invoice) => {
        array.push({
          date: invoice.invoice_date
            ? this.timeToDate(invoice.invoice_date)
            : "",
          reference: invoice.designation,
          invoiced: invoice.amount,
          paid: "",
          operation_type: invoice.operation_type,
          balance: 0,
          type: "invoice",
          invoice: invoice,
        });
      });

      this.transactions.forEach((transaction) => {
        array.push({
          date: transaction.payment_date
            ? this.timeToDate(transaction.payment_date)
            : "",
          reference: transaction.reference,
          invoiced: "",
          paid: transaction.amount - transaction.charges_amount,
          operation_type: transaction.operation_type,
          balance: 0,
          type: "transaction",
          transaction: transaction,
        });
      });

      // CompanyBalance emitted transfers
      this.companyBalance.emitter_company_balance_transfers.map((e) => {
        array.push({
          date: this.timeToDate(e.emitter_transfer_date),
          reference: `Transfer to ${e.recipient_company_balance.company_name}`,
          invoiced: "",
          paid: e.emitter_amount,
          operation_type:
            this.companyBalance.company_type == "customer" ? "debit" : "credit",
          balance: 0,
          type: "transaction",
        });
      });

      // CompanyBalance received transfers
      this.companyBalance.recipient_company_balance_transfers.map((e) => {
        array.push({
          date: this.timeToDate(e.recipient_transfer_date),
          reference: `Transfer from ${e.emitter_company_balance.company_name}`,
          invoiced: "",
          paid: e.recipient_amount,
          operation_type:
            this.companyBalance.company_type == "customer" ? "credit" : "debit",
          balance: 0,
          type: "transaction",
        });
      });
      var self = this;
      // Sort array by date before calculating balance && totals.
      array = array.sort(function (a, b) {
        if (
          self.strToTimestamp(b.date, "DD/MM/YYYY") >
          self.strToTimestamp(a.date, "DD/MM/YYYY")
        )
          return -1;
        else return 1;
      });

      this.total_invoiced = 0;
      this.total_paid = 0;
      var temp_invoiced, temp_paid;

      // calculating balance && totals
      array.forEach((event) => {
        temp_invoiced =
          event.type == "invoice"
            ? event.operation_type == "debit"
              ? -event.invoiced
              : event.invoiced
            : 0;
        temp_paid =
          event.type == "transaction"
            ? event.operation_type == "debit"
              ? -event.paid
              : event.paid
            : 0;

        if (this.companyBalance.company_type == "supplier") {
          this.total_invoiced += temp_invoiced;
          this.total_paid -= temp_paid;
        } else {
          this.total_invoiced -= temp_invoiced;
          this.total_paid += temp_paid;
        }

        if (
          this.companyBalance.company &&
          this.companyBalance.company.isSupplier
        ) {
          if (event.type == "invoice") this.total_balance += temp_invoiced;
          else this.total_balance -= temp_paid;
        } else {
          if (event.type == "invoice") this.total_balance -= temp_invoiced;
          else this.total_balance += temp_paid;
        }

        event.balance = this.total_balance.toFixed(2);
      });

      // Now that we have all items, proper balances calculations etc,
      // we can simply add the hidden property to each element
      // related to the dates they havebundleRenderer.renderToStream

      var temp_date;

      array.forEach((item) => {
        temp_date = item.date
          ? this.strToTimestamp(item.date, "DD/MM/YYYY")
          : "";

        item.hidden =
          temp_date != "" &&
          !(
            temp_date >= this.datePickerFromAsDateObject &&
            temp_date <= this.datePickerToAsDateObject
          );
      });

      return array;
    },
    statementItems() {
      // Initial amount
      if (this.companyBalance.initial_value != 0) {
        let tmpdate = this.strToTimestamp(
          this.companyBalance.created_at,
          "DD/MM/YYYY"
        );
        this.invoiceTransactionsAndTransfers.unshift({
          date: "",
          reference: "Account initialization",
          paid: "",
          operation_type:
            this.companyBalance.initial_value >= 0 ? "credit" : "debit",
          balance: this.companyBalance.initial_value,
          type: "init",
          hidden:
            tmpdate >= this.datePickerFromAsDateObject &&
            tmpdate <= this.datePickerToAsDateObject,
        });
      }

      return this.invoiceTransactionsAndTransfers;
    },
    itemsToDisplay() {
      return this.statementItems.filter((i) => {
        return i.hidden === false;
      });
    },
    exportFileName() {
      return (
        this.companyName.replace(/[^a-z0-9_-]/gi, "").toLowerCase() +
        "_account_statement_" +
        this.companyBalance.currency.code
      );
    },
  },
  methods: {
    filter(object) {
      console.log(object);
      return object.hidden === false;
    },
    getOldestDate() {
      if (this.invoices.length === 0 && this.transactions.length > 0)
        return new Date().toISOString().substr(0, 10);
      if (this.invoices.length != 0)
        var oldestDate = this.invoices[0].invoice_date;
      else if (this.transactions.length != 0)
        var oldestDate = this.transactions[0].payment_date;

      this.invoices.forEach((invoice) => {
        if (
          this.strToTimestamp(invoice.invoice_date, "YYYY-MM-DD") <
          this.strToTimestamp(oldestDate, "YYYY-MM-DD")
        ) {
          oldestDate = invoice.invoice_date;
        }
      });

      this.transactions.forEach((transaction) => {
        if (
          this.strToTimestamp(transaction.payment_date, "YYYY-MM-DD") <
          this.strToTimestamp(oldestDate, "YYYY-MM-DD")
        ) {
          oldestDate = transaction.payment_date;
        }
      });

      return oldestDate;
    },
    updateDateRangeQuery() {},
    selectedDatePickerFrom() {
      this.datePickerShowFrom = false;
      this.datePickerRangeSelectedItem = "Custom";
    },
    selectedDatePickerTo() {
      this.datePickerShowTo = false;
      this.datePickerRangeSelectedItem = "Custom";
    },
    datePickerUpdate(event) {
      // "Custom",
      //         "Last 3 months",
      //         "Last 6 months",
      //         "This year",
      //         "All"
      if (event == "Last 3 months") {
        this.datePickerFrom = new Date(this.monthsAgo(3))
          .toISOString()
          .substr(0, 10);
        this.datePickerTo = new Date().toISOString().substr(0, 10);
        this.datePickerRangeSelectedItem = "Last 3 months";
      }

      if (event == "Last 6 months") {
        this.datePickerFrom = new Date(this.monthsAgo(6))
          .toISOString()
          .substr(0, 10);
        this.datePickerTo = new Date().toISOString().substr(0, 10);
        this.datePickerRangeSelectedItem = "Last 6 months";
      }

      if (event == "This year") {
        this.datePickerFrom = new Date(this.startOfTheYear())
          .toISOString()
          .substr(0, 10);
        this.datePickerTo = new Date().toISOString().substr(0, 10);
        this.datePickerRangeSelectedItem = "This year";
      }

      if (event == "All") {
        this.datePickerFrom = new Date(this.yearsAgo(100))
          .toISOString()
          .substr(0, 10);
        this.datePickerTo = new Date().toISOString().substr(0, 10);
        this.datePickerRangeSelectedItem = "All";
      }
    },
    exportAsPDF() {
      var self = this;
      this.generatingPdf = true;

      self
        .sendQuery(ACCOUNTING_STATEMENT_PDF_BLOB, {
          body: this.pdfHtml(),
        })
        .then((data) => {
          // create blob from pdf
          self.generatingPdf = false;
          var b64pdfstr = data.accounting_statement_pdf;
          var content = b64pdfstr.replace(
            "data:application/pdf;filename=generated.pdf;base64,",
            ""
          );
          var binary = atob(content.replace(/\s/g, ""));
          var len = binary.length;
          var buffer = new ArrayBuffer(len);
          var view = new Uint8Array(buffer);
          for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          var blob = new Blob([view], { type: "application/pdf" });

          // let name = self.custom_view.name + ".pdf";
          // var file = new File([blob], name, {
          //   lastModified: new Date(0),
          //   type: "application/pdf"
          // });

          // generate a temp download btn
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.exportFileName + ".pdf";
          document.body.append(link);
          link.click();
          link.remove();
          window.addEventListener(
            "focus",
            (e) => URL.revokeObjectURL(link.href),
            { once: true }
          );
        })
        .catch((e) => {
          self.generatingPdf = false;
          console.log(e);
        });
    },
    exportAsXLSX() {
      this.excelData.filename = this.exportFileName + ".xlsx";
      var items = [];

      this.statementItems.forEach((e) => {
        items.push({
          date: e.date,
          reference: e.reference,
          invoices: this.amountAsText(e, "invoice"),
          payments: this.amountAsText(e, "transaction"),
          //operation_type: e.operation_type,
          balance: e.balance,
          // type: e.type
        });
      });
      // Footer
      items.push({
        date: "",
        reference: "Total:",
        invoices: this.inCurrencyFromId(this.currencyId, this.total_invoiced),
        payments: this.inCurrencyFromId(this.currencyId, this.total_paid),
        //operation_type: e.operation_type,
        balance: this.inCurrencyFromId(this.currencyId, this.total_balance),
        // type: e.type
      });

      this.excelData.sheetsData = [items];
      /* Trigger export on exportExcel component */
      this.excelData.exportTriggerKey++;
    },
    pdfHtml() {
      var ret_html = this.ctc_header_pdf;

      // Date of pdf
      ret_html = ret_html.replace("{header_date}", this.timeToDate(new Date()));

      // Company Name
      ret_html = ret_html.replace(
        "{company_name}",
        this.companyName + " (" + this.companyBalance.currency.code + ")"
      );

      // Company Address
      var temp_address = [];
      if (
        this.companyBalance.company &&
        this.companyBalance.company.city &&
        this.companyBalance.company.city.name
      ) {
        temp_address.push(
          this.companyBalance.company.city.name.replace(".", "")
        );
      }
      if (
        this.companyBalance.company &&
        this.companyBalance.company.country &&
        this.companyBalance.company.country.name
      ) {
        temp_address.push(
          this.companyBalance.company.country.name.replace(".", "")
        );
      }
      ret_html = ret_html.replace("{company_address}", temp_address.join(", "));

      // Headers
      var html_headers = "";
      this.headers.map(function (col) {
        html_headers +=
          '<th  height="15" valign="middle" style="font-family:\'arial\',arial,sans-serif; font-size: 10px; padding: 6px 8px; text-align:left; background-color:#1976d2; color:white;">' +
          col.text +
          "</th>";
      });
      ret_html = ret_html.replace("{headers_columns}", html_headers);

      // Rows
      var html_rows = "";
      var html_rows_tds = "";
      var tr_base_html =
        '<tr style="border-top: 1px solid rgba(0,0,0,.12);">{tds_html}</tr>';
      var td_base_html =
        '<td min-height="30" valign="middle" style="font-family:\'arial\',arial,sans-serif; white-space: nowrap; font-size: 10px; padding: 6px 8px; line-height:12px;min-height:25px; vertical-align:middle ">{value_to_replace}</td>';

      this.statementItems.forEach((item) => {
        if (!item.hidden) {
          // Cleaning
          html_rows_tds = "";

          // Date
          html_rows_tds += td_base_html.replace(
            "{value_to_replace}",
            item.date
          );

          // Reference
          html_rows_tds += td_base_html.replace(
            "{value_to_replace}",
            item.reference.replace(/\n/g, "<br />")
          );

          //Invoice Amount
          html_rows_tds += td_base_html.replace(
            "{value_to_replace}",
            '<strong style="' +
              this.styleFromClass(
                this.amountColorClass(
                  "invoice",
                  item.invoiced,
                  item.operation_type
                )
              ) +
              '">' +
              this.amountAsText(item, "invoice") +
              "</strong>"
          );

          //Transaction Amount
          html_rows_tds += td_base_html.replace(
            "{value_to_replace}",
            '<strong style="' +
              this.styleFromClass(
                this.amountColorClass(
                  "transaction",
                  item.paid,
                  item.operation_type
                )
              ) +
              '">' +
              this.amountAsText(item, "transaction") +
              "</strong>"
          );

          //Balance Amount
          html_rows_tds += td_base_html.replace(
            "{value_to_replace}",
            this.inCurrencyFromId(this.currencyId, item.balance)
          );

          //Building row html
          html_rows += tr_base_html.replace("{tds_html}", html_rows_tds);
        }
      });

      // Cleaning for footer
      html_rows_tds = "";

      // Empty
      html_rows_tds += td_base_html.replace("{value_to_replace}", "");

      // Total
      html_rows_tds += td_base_html.replace(
        "{value_to_replace}",
        '<span style="float: right;">Total:</span>'
      );

      // Total Invoices
      html_rows_tds += td_base_html.replace(
        "{value_to_replace}",
        "<strong>" +
          this.inCurrencyFromId(this.currencyId, this.total_invoiced) +
          "</strong>"
      );

      // Total Paid
      html_rows_tds += td_base_html.replace(
        "{value_to_replace}",
        "<strong>" +
          this.inCurrencyFromId(this.currencyId, this.total_paid) +
          "</strong>"
      );

      // Total Balance
      html_rows_tds += td_base_html.replace(
        "{value_to_replace}",
        '<strong style="font-size:12px; color: #' +
          (this.total_balance >= 0 ? "4CAF50" : "FF5252") +
          '">' +
          this.inCurrencyFromId(this.currencyId, this.total_balance) +
          "</strong>"
      );

      //Building row html
      html_rows += tr_base_html.replace("{tds_html}", html_rows_tds);

      //Merging all rows into body table
      ret_html = ret_html.replace("{body_rows}", html_rows);

      return ret_html;
    },
    displayInvoicePreview(invoice) {
      this.showInvoiceDialog = true;
      this.showInvoiceObject = invoice;
    },
    amountColorClass(type, value, operation_type) {
      if (type == "transaction") {
        if (this.companyBalance.company_type == "supplier")
          return operation_type == "debit" ? "success--text" : "error--text";
        else return operation_type == "debit" ? "error--text" : "success--text";
      }

      if (type == "invoice") {
        if (this.companyBalance.company_type == "supplier")
          return operation_type == "debit" ? "error--text" : "success--text";
        else return operation_type == "debit" ? "success--text" : "error--text";
      }

      return "";
    },
    styleFromClass(class_string) {
      switch (class_string) {
        case "error--text":
          return "color: #FF5252;";
        case "success--text":
          return "color: #4CAF50;";
      }
    },
    amountAsText(item, type) {
      var ret = "";
      if (type == "transaction") {
        if (!item.paid) return "";
        if (this.companyBalance.company_type == "supplier")
          ret = item.operation_type == "debit" ? "+" : "-";
        else ret = item.operation_type == "debit" ? "-" : "+";
      }

      if (type == "invoice") {
        if (!item.invoiced) return "";
        if (this.companyBalance.company_type == "supplier")
          ret = item.operation_type == "debit" ? "-" : "+";
        else ret = item.operation_type == "debit" ? "+" : "-";
      }

      return (ret += this.inCurrencyFromId(
        this.currencyId,
        type == "invoice" ? item.invoiced : item.paid
      ));
    },
    sortBy(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
  },
  watch: {},
  created() {},
};
</script>
